import { api } from '@/core/api/';

//ECG:filters contiene {name:'nombredefiltro', value:'valordelfiltro'}
export const getPermissions = (filters) => api.get('/api/permissions', {
    params: filters
})


export const getUsers = (permissionId, filters) => api.get(`/api/permissions/users/${permissionId}`, {
    params: filters
})

export const removeUsers = (permissionId, users) => api.post(`/api/permissions/removeusers/${permissionId}`, users)

export const getRoles = (permissionId, filters) => api.get(`/api/permissions/roles/${permissionId}`, {
    params: filters
})

export const removeRoles = (permissionId, roles) => api.post(`/api/permissions/removeroles/${permissionId}`, roles)